/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Drag_DropInputs */

const en_nav_app_drag_drop = /** @type {(inputs: Nav_App_Drag_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag and drop or click to upload`)
};

const es_nav_app_drag_drop = /** @type {(inputs: Nav_App_Drag_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra y suelta o haz clic para subir`)
};

/**
* | output |
* | --- |
* | "Drag and drop or click to upload" |
*
* @param {Nav_App_Drag_DropInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_drag_drop = /** @type {((inputs?: Nav_App_Drag_DropInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Drag_DropInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_drag_drop(inputs)
	return en_nav_app_drag_drop(inputs)
});